<template>
  <div class="news">
    <template v-for="(item, index) in news">
      <a :key="index" class="news-item" :href="item.linkUrl">
        <img class="poster" :src="item.poster" />
        <div class="content">
          <div class="title">{{item.title}}</div>
          <div class="add">
            <span>{{item.category}}</span>
            <span>{{item.release_time}}</span>
          </div>
        </div>
      </a>
    </template>
  </div>
</template>

<script>
  import { news } from './config';

  export default {
    name: 'HomeNews',
    created() {
      this.news = news;
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.news-item {
  display: block;
  padding: 15px;
  background-color: #fff;
  border-radius: 4px;
  @include flex-between();

  .poster {
    width: 100px;
    height: 60px;
    border: 1px solid rgba(255, 255, 255, 0.8);
    border-radius: 2px;
  }

  .content {
    flex: 1;
    margin-left: 15px;
    height: 60px;
    @include flex-between(column);

    .title {
      font-size: 14px;
      color: #333;
      line-height: 1.25;
      @include multiline-ellipsis(2);

      &::after {
        margin-left: 8px;
        content: "HOT";
        background-color: #fb8c42;
        color: #fff;
        font-size: 12px;
        padding: 0 5px;
        border-radius: 8px;
      }
    }

    .add {
      width: 100%;
      color: #999;
      @include flex-between();
    }
  }
}
</style>
